import { render, staticRenderFns } from "./ReportTabGroupMealsTabEmployees.vue?vue&type=template&id=106bdde2"
import script from "./ReportTabGroupMealsTabEmployees.vue?vue&type=script&lang=js"
export * from "./ReportTabGroupMealsTabEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports